<template>
  <section class="custom-ranges">
    <table>
      <thead>
        <tr>
          <th>Low</th>
          <th>Optimal</th>
          <th>Moderate</th>
          <th>High</th>
          <th>Very High</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ low }}</td>
          <td>{{ optimal }}</td>
          <td>{{ moderate }}</td>
          <td>{{ high }}</td>
          <td>{{ veryhigh }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
export default {
  name: 'bodyfat-ranges',
  props: {
    ranges: {
      type: Object,
      default: null,
    },
  },
  computed: {
    low() {
      return this.ranges ? `0% - ${this.ranges['Low']['1']}%` : null
    },
    optimal() {
      return this.ranges
        ? `${this.ranges['Optimal']['0']}% - ${this.ranges['Optimal']['1']}%`
        : null
    },
    moderate() {
      return this.ranges
        ? `${this.ranges['Moderate']['0']}% - ${this.ranges['Moderate']['1']}%`
        : null
    },
    high() {
      return this.ranges
        ? `${this.ranges['High']['0']}% - ${this.ranges['High']['1']}%`
        : null
    },
    veryhigh() {
      return this.ranges ? `> ${this.ranges['Very High']['0']}%` : null
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-ranges {
  width: 100%;
  font-size: 0.8em;
  table {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
    border: 1px solid;
  }
  table th {
    border: 1px solid gray;
    padding: 4px;
    text-align: center;
  }
  table td {
    border: 1px solid gray;
    padding: 4px;
    text-align: center;
  }
}
</style>
